export default {
  upload_common: {
    required: 'Pertanyaan ini wajib diisi',
    max_length_500: 'Silakan jawab dalam 500 kata.',
    please_enter_a_number: 'Masukkan angka',
    unexpected_error: 'Terjadi kesalahan yang tidak terduga',
    temporarily_saved: 'Disimpan',
    unanswered_items: 'Ada pertanyaan yang belum terjawab',
    answer_questionnaire_select: 'Pilih survei',
    entry: 'Tuliskan jawaban Anda.',
    target_select: 'Pilih',
    value_unit: 'Angka',
    unit: 'Unit',
    attach_documents: 'Lampirkan file',
    textarea_placeholder: 'Tuliskan jawaban Anda jika diperlukan, atau jika Anda ingin menambahkan penjelasan tambahan.',
    temporary_storage: 'Simpan',
    submit: 'Kirim',
    last_saved_temporary: 'Terakhir diperbarui',
    There_are_unanswered_questions: 'Ada pertanyaan yang belum terjawab',
    submitted_text: 'Survei ini telah dikirim.',
    submitted_at: 'Tanggal Pengiriman',
    withdrawal_of_answer: 'Tarik kembali pengiriman',
    withdrawal_accepted: 'Penarikan diterima',
    help: 'Bantuan',
    example_of_evidence: 'Contoh bukti',
    save_temporary_answer: 'Simpan Survei',
    saved_temporary_answer: 'Jawaban Anda telah disimpan.',
    submit_answer: 'Kirim Survei',
    confirm_submit_answer: 'Anda yakin ingin mengirimkan survei?',
    confirm_submit_shared_text: '\nRespons Anda terhadap survei akan dibagikan kepada pembeli Anda.',
    complete_submit_answer: 'Survei telah dikirim. \nTerima kasih atas kerja sama Anda.',
    back_answer: 'Kembali',
    close: 'Tutup',
    save_temporary_answer_and_prev: 'Simpan dan kembali',
    save_temporary_answer_and_next: 'Simpan dan lanjutkan berikutnya',
    prev: 'Kembali',
    next: 'Berikutnya',
    question_group_question_download: 'Unduh Survei',
    question_group_answer_download: 'Unduh jawaban',
    question_group_download_answer_csv_title: 'Pertanyaan・Jawaban(CSV)',
    question_group_download_answer_csv_description: 'Unduh jawaban dalam bentuk csv.',
    question_group_download_answer_pdf_title: 'Pertanyaan・Jawaban(PDF)',
    question_group_download_answer_pdf_description: 'Unduh jawaban dalam format pdf.',
    question_group_download_scorecard_pdf_title: 'Kartu Skor(PDF)',
    question_group_download_scorecard_pdf_description: 'Unduh skor dalam format pdf.',
    question_group_download_esg_award_svg_title: 'Penghargaan ESG(SVG)',
    question_group_download_esg_award_svg_description: 'Unduh penghargaan dalam format svg.',
    question_group_download_esg_award_pdf_title: 'Penghargaan ESG(PDF)',
    question_group_download_esg_award_pdf_description: 'Unduh penghargaan dalam format pdf.',
    request_survey_withdrawal: 'Minta penarikan survei',
    survey_withdrawal_description: 'Permintaan penarikan akan dikirimkan ke Pembeli Anda.Silakan nyatakan alasan di bawah ini mengapa Anda ingin membatalkan survei. \nDetail permintaan Anda akan dibagikan kepada Pembeli Anda.',
    reason_withdrawal_request: 'Alasan permintaan penarikan',
    completed_withdrawal_request: 'Permintaan penarikan Anda telah diterima. Silakan tunggu hingga disetujui.',
    send: 'Kirim',
    cancel: 'Batalkan',
    balloon_title_withdrawal_request: 'Permintaan penarikan Anda telah diterima. ',
    no_survey: 'Tidak ada permintaan survei yang tersedia.',
    failed_to_save_before_export: 'Penyimpanan sementara sebelum pengunduhan gagal. Silakan pastikan bahwa informasi yang dimasukkan sudah benar',
    filter_unfilled_questions: 'Tampilkan hanya survei yang belum terjawab',
    no_unfilled_questions: 'Tidak ada pertanyaan yang belum terjawab',
    move_page: 'Buka halaman berikutnya',
    confirm_move_page_message: 'Jawaban Anda tidak disimpan. \nJika Anda pindah ke halaman lain, jawaban Anda akan hilang.Apakah Anda ingin menyimpan jawaban sebelum pindah?',
    confirm_without_save: 'Jangan simpan',
    confirm_with_save: 'Simpan',
    error_save: 'Tidak dapat menyimpan sementara. Periksa jawaban Anda.',
    // there_are_no_unanswered_questions: "",
    someone_editing_survey: 'Survei Sedang Diedit',
    unable_edit_someone_editing_survey: 'Survei tidak dapat diedit saat ini karena ada pengguna yang sedang mengeditnya.',
    user_editing_survey: 'sedang mengedit.',
    reference_question: {
      // see_previous_answers: "",
      previous_answers: 'Jawaban sebelumnya',
      // overwrite_with_previous_answers: "",
      submitted_at: '(Dikirim pada {submitted_at})',
      // related_question: "",
      click_to_expand: 'Klik untuk memperbesar',
      click_to_omit: 'Klik untuk menghapus',
      // description: "",
      answer_reference_function: 'Fungsi referensi jawaban',
      overwrite: 'Timpa',
      overwrite_confirm: 'Tindakan ini akan mengisi jawaban sebelumnya untuk pertanyaan yang telah dijawab dalam survei sebelumnya.\nPertanyaan apa pun yang sudah terjawab akan ditimpa.',
      question_group: '@:question_group_section.list_header_question',
    },
    energy_question: {
      scope: 'Scope',
      item: 'Item',
      activity_amount: 'Jumlah',
      emission_factor: 'Faktor emisi',
      emission_amount: 'Emisi',
      unit_sale: 'Intensitas Emisi',
      total: 'Total',
      emission_amount_unit: 'tCO2',
      unit_sale_unit: 'tCO2/satu juta YEN',
    },
    label: {
      required_answer: 'Jawaban Wajib',
      optional_answer: 'Jawaban Opsional',
      conditional_required_answer: 'Jawaban Wajib Bercabang',
      note: 'Catatan',
      // evidence_attachments: "",
    },
    // no_available_in_pdf: "",
    // comparison_question_meta: "",
    question_group_download_answered_csv_title: 'Pertanyaan・Jawaban(CSV)',
    question_group_download_answered_pdf_title: 'Pertanyaan・Jawaban(PDF)',
  },
}
